/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../pages/auth/authSlice";
import useSelection from "antd/es/table/hooks/useSelection";
import { checkPrivilege } from "../../../CommonMethods/checkPrivilege";
import { Auth, Hub } from "aws-amplify";
import { removePrivilages } from "../../../pages/auth/privilagesSlice";
import { motion } from "framer-motion";
import GlobalContext from "../../Context/GlobalContext";

export default function Sidebar() {
    const [selectedOption, setSelectedOption] = useState("dashboard");
    const location = useLocation();
    const dispactch = useDispatch();
    const privileges = useSelector((state) => state.Privilages.privileges);
    const navigate = useNavigate();
    const auth = useSelector((state) => state.auth);
    const [showlogout, setLogout] = useState(false);
    const [logoutHover, setLogoutHover] = useState(false);
    const { loggedIn, user_name } = auth;

    const { sideBar, setSideBar } = useContext(GlobalContext);

    function getInitials(fullName) {
        if (!fullName) {
            return;
        }

        // Remove extra spaces and split into words
        const words = fullName.trim().split(/\s+/);

        // Check if any words are present
        if (!words.length) {
            return ""; // Return empty string if no words found
        }

        if (words.length === 1) {
            return `${words[0][0]}`.toUpperCase();
        }

        // Return first letter of the first word and last word (uppercase)
        return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
    }

    function getTwoWords(fullName) {
        if (!fullName) {
            return;
        }
        // Remove extra spaces and split into words
        const words = fullName.trim().split(/\s+/);

        // Check if any words are present
        if (!words.length) {
            return ""; // Return empty string if no words found
        }

        if (words.length === 1) {
            return words[0];
        }

        // Return first letter of the first word and last word (uppercase)
        return `${words[0]} ${words[words.length - 1]}`;
    }

    const sideNavObject = {
        Dashboard: {
            path: "/dashboard",
            img: `/assets/images/${!location.pathname.includes("dashboard")
                ? "dashboard.svg"
                : "dashboard-active.svg"
            }`,
            mainClass: `${location.pathname.includes("dashboard") ? "bg-[#9C236333] rounded" : ""
            }`,
            ptag: `${location.pathname.includes("dashboard")
                ? "text-[#9C2363]"
                : "text-[#4B4B4B]"
            }`,
            privilegeRequired: "view_dashboard",
        },
        "Admin Users": {
            path: "/manage-admin-users",
            // "path":'/',
            // img:`/assets/images/${(location.pathname.includes('manage-admin-users') || location.pathname === '/') ? 'whiteusers.svg':'user-active.svg'}`,
            img: `${location.pathname.includes("manage-admin-users") ||
                location.pathname === "/"
                ? "/assets/images/user-active.svg"
                : "/assets/images/whiteusers.svg"
            }`,
            mainClass: `${location.pathname.includes("manage-admin-users") ||
                location.pathname === "/"
                ? "bg-[#9C236333] rounded"
                : ""
            }`,
            ptag: `${location.pathname.includes("manage-admin-users") ||
                location.pathname === "/"
                ? "text-[#9C2363]"
                : "text-[#4B4B4B]"
            }`,
            privilegeRequired: "admin_user_list",
        },
        Merchants: {
            path: "/manage-merchants",
            img: `/assets/images/${!location.pathname.includes("manage-merchants")
                ? "users.svg"
                : "active-merchant1.png"
            }`,
            mainClass: `${location.pathname.includes("manage-merchants")
                ? "bg-[#9C236333] rounded"
                : ""
            }`,
            ptag: `${location.pathname.includes("manage-merchants")
                ? "text-[#9C2363]"
                : "text-[#4B4B4B]"
            }`,
            privilegeRequired: "merchant_list",
        },
        Customers: {
            path: "/customers",
            img: `/assets/images/${!location.pathname.includes("customers")
                ? "customer-inactive.svg"
                : "customer-active.svg"
            }`,
            mainClass: `${location.pathname.includes("customers")
                ? "bg-[#9C236333] rounded"
                : ""
            }`,
            ptag: `${location.pathname.includes("customers")
                ? "text-[#9C2363]"
                : "text-[#4B4B4B]"
            }`,
            privilegeRequired: "customer_list",
        },
        "Orders/Purchases": {
            path: "/orders-purchases",
            img: `/assets/images/${!location.pathname.includes("orders-purchases")
                ? "basket-icon 1.svg"
                : "active-basket-icon.svg"
            }`,
            mainClass: `${location.pathname.includes("/orders-purchases")
                ? "bg-[#9C236333] rounded"
                : ""
            }`,
            ptag: `${location.pathname.includes("/orders-purchases")
                ? "text-[#9C2363]"
                : "text-[#4B4B4B]"
            }`,
            privilegeRequired: "order_list",
        },
        Support: {
            path: "/supports",
            img: `/assets/images/${!location.pathname.includes("supports")
                ? "like.svg"
                : "active-support.svg"
            }`,
            mainClass: `${location.pathname.includes("supports") ? "bg-[#9C236333] rounded" : ""
            }`,
            ptag: `${location.pathname.includes("supports")
                ? "text-[#9C2363]"
                : "text-[#4B4B4B]"
            }`,
            privilegeRequired: "support_request_list",
        },
        "Settlements": {
            path: "/settlements",
            img: `/assets/images/${!location.pathname.includes("/settlements")
                ? "crypto-settlement-icon.svg"
                : "active-crypto-settlement-icon.svg"
            }`,
            mainClass: `${location.pathname.includes("/settlements")
                ? "bg-[#9C236333] rounded"
                : ""
            }`,
            ptag: `${location.pathname.includes("/settlements")
                ? "text-[#9C2363]"
                : "text-[#4B4B4B]"
            }`,
            privilegeRequired: "settlement_list",
        },
        'Password Update': {
            "path": '/password-update',
            img: `/assets/images/${!location.pathname.includes('/password-update')
                ? 'key.svg' 
                : 'key-active.svg'
            }`,
            mainClass: `${location.pathname.includes('/password-update')
                ? 'bg-[#9C236333] '
                : ''
            }`,
            ptag: `${location.pathname.includes('/password-update')
                ? 'text-[#9C2363]'
                : 'text-[#4B4B4B]'
            }`,
            privilegeRequired: 'allowed'
        },
    };
    const handleLogout = () => {
        const loggedOut = Auth.signOut();
        dispactch(logout());
        dispactch(removePrivilages());
        navigate("/");
    };
    const handleNavigate = (obj) => {
        console.log(location.pathname, obj.path);
        if (location.pathname === `${obj.path}`) {
            return;
        } else {
            navigate(obj.path);
        }
    };

    return (
        // <div className={`h-[100vh] bg-[#fff] flex flex-col  fixed ${!sideBar ? 'w-[224px]' : 'w-[70px]'}`}>
        <motion.div
            className="h-[100vh] bg-[#fff] flex flex-col fixed z-[999]"
            animate={{ width: sideBar ? "70px" : "224px" }}
            transition={{ duration: 0.3 }}
        >

            {/* <div className="w-fit h-full"> */}
            {/* <div className={`bg-primary ${!sideBar ? 'pl-[24px] pr-[24px]' : 'px-2'} py-[41px] h-[110px] `}> */}
            <motion.div
                className="bg-primary py-[41px] h-[110px]"
                initial={{ paddingLeft: sideBar ? "8px" : "24px", paddingRight: sideBar ? "8px" : "24px" }}
                animate={{ paddingLeft: sideBar ? "8px" : "24px", paddingRight: sideBar ? "8px" : "24px" }}
                transition={{ duration: 0.3 }}
            >
                <div>
                    <img
                        src={!sideBar ? `/assets/images/Maison QR white full logo.svg` : '/assets/images/mqr-small.svg'}
                        alt=""
                        className={`${!sideBar ? 'w-full' : 'h-[20px]'} cursor-default`}
                    />
                </div>

                {!sideBar && (
                    <motion.h1
                        className="text-center text-white font-medium mt-1"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        Admin
                    </motion.h1>
                )}
                <div className={`flex r ${!sideBar ? 'justify-end' : 'justify-center'}`}>
                    <motion.img
                        animate={{ rotate: sideBar ? 0 : 180 }}
                        transition={{ duration: 0.1 }}
                        src="/assets/images/header-right.svg" className={`${!sideBar ? '-mt-2 -mr-3' : 'mt-3'} h-[20px] w-[54px]`} alt="" onClick={() => setSideBar(!sideBar)} />
                </div>
                {/* <h1 className="text-xl text-white font-medium">
                    Maison QR | <span className="text-base">Admin</span>
                    </h1>*/}
            </motion.div>
            <motion.div
                className={`mt-[14px] flex flex-col grow ${sideBar && 'items-center'} justify-between pb-[18px]`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
            >
                <ul className={`px-[12px] ${sideBar && 'w-fit'}`}>
                    {Object.keys(sideNavObject).map(
                        (nav) =>
                            (checkPrivilege(sideNavObject[nav]?.privilegeRequired) || sideNavObject[nav]?.privilegeRequired ==='allowed')  && (
                                <motion.li
                                    key={nav}
                                    onClick={() => handleNavigate(sideNavObject[nav])}
                                    className={`mt-[4px] pl-2 py-[17px] flex space-x-2 items-center cursor-pointer ${sideNavObject[nav].mainClass} ${sideBar && 'w-fit pr-2'}`}
                                    initial={{ opacity: 0, x: sideBar ? -50 : 0 }}
                                    data-testid={nav}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <img src={sideNavObject[nav].img} alt={nav} />
                                    {!sideBar && (
                                        <motion.p
                                            className={`font-crimson ${sideNavObject[nav].ptag} text-base font-normal`}
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            {nav}
                                        </motion.p>
                                    )}
                                </motion.li>
                            )
                    )}
                </ul>
                {/* <div className="px-3 cursor-pointer" onClick={() => dispactch(logout())}>
                    <div className=" flex space-x-[13px] justify-center items-center border-[1px] rounded-[4px] pr-[10px] pl-[7px] py-[10px] border-primary">
                        <h1 className="px-[11px] py-[11px] text-base font-semibold text-white leading-6 bg-primary rounded-full">
                            {getInitials(user_name)}
                        </h1>
                        <p className="text-base text-[#4B4B4B] font-normal capitalize max-w-[77px] text-ellipses whitespace-nowrap">
                            {getTwoWords(user_name)}
                        </p>
                        <img src="/assets/images/chevron-right.svg" alt="" />
                    </div>
                </div> */}
                <div className="px-3 cursor-pointer">
                    {showlogout && (
                        <div
                            className={`w-full flex items-center pl-4 py-[17px] rounded-[4px] mb-2 ${logoutHover ? "bg-[#9C236333]" : "bg-white"}`}
                            data-testid="logout-btn"
                            onMouseEnter={() => setLogoutHover(true)}
                            onMouseLeave={() => setLogoutHover(false)}
                            onClick={() => handleLogout()}
                        >
                            <motion.img
                                src={`${logoutHover
                                    ? "/assets/images/logout-active.svg"
                                    : "/assets/images/logout.svg"
                                }`}
                                className="w-[18px] h-[18px] mr-2"
                                alt=""
                                
                            />
                            {!sideBar && <h1
                                className={`font-normal text-base ${logoutHover ? "text-[#9E2064]" : "text-[#4B4B4B]"
                                }`}
                            >
                                Logout
                            </h1>}
                        </div>
                    )}
                    <motion.div
                        className={`${sideBar && 'w-fit'} flex space-x-[13px] justify-center items-center border-[1px] rounded-[4px] pr-[10px] pl-[7px] py-[10px] border-primary`}
                        data-testid="logout-opt"
                        onClick={() => setLogout(!showlogout)}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                    >
                        <h1 className="px-[11px] py-[11px] text-base font-semibold text-white leading-6 bg-primary rounded-full">
                            {getInitials(user_name)}
                        </h1>
                        {!sideBar && (
                            <motion.p
                                className="text-base text-[#4B4B4B] font-normal capitalize max-w-[77px] overflow-hidden whitespace-nowrap text-ellipsis"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.3 }}
                            >
                                {getTwoWords(user_name)}
                            </motion.p>
                        )}
                        {!sideBar && (
                            <motion.img
                                animate={{ rotate: showlogout ? -90 : 0 }}
                                src="/assets/images/chevron-right.svg"
                                alt=""
                            />
                        )}
                    </motion.div>
                </div>
            </motion.div>
        </motion.div >
    );
}
